import qs from 'qs';
import { service } from '../../config';
import Http from '../../lib/Http';
import { Container, Contents, ContentsData, editorState, Email, HistoryItem, ListVars, MergeFields, SavedBox, SavedBoxListResponse } from './types';

declare var daum: any;

const editorToken = localStorage.getItem('EditorToken');

export function requestContentsLocal(saveKey:string): ContentsData {
	const data:any = localStorage.getItem(saveKey) ? localStorage.getItem(saveKey) : JSON.stringify({ lastModifiedTime: -1, data: []});	
	return JSON.parse(data);	
}

export function putContentsLocal(saveKey:string, data: ContentsData) {
	localStorage.setItem(saveKey, JSON.stringify(data));
}

export async function requestContents(emailId:number, testGroup?: editorState['testGroup']) {
	let requestUrl = `/editor/${emailId}/content`;
	if (testGroup) requestUrl = requestUrl + `?type=${testGroup}`;

	try {
		const response = await Http.get<ContentsData>(
			requestUrl,
		);
		return response.data;		
	} catch (error) {
		console.error(error);
		return { lastModifiedTime: -1, data: null };
	}
}

export async function requestOldContents(emailId:number) {
	try {
		const response = await Http.get(
			`/editor/${emailId}/contents` // contents -> content
		);
		return response.data === null ? [] : response.data; 
	} catch (error) {
		console.error(error);
		return { lastModifiedTime: -1, data: [] };
	}
}

export async function postContents(emailId:number, data: ContentsData, testGroup?: editorState['testGroup']) {
	let requestUrl = `/editor/${emailId}/content`;
	if (testGroup) requestUrl = requestUrl + `?type=${testGroup}`;

	const response = await Http.post<Contents>(
		requestUrl,
		JSON.stringify(data),
		{headers: {
			'Content-Type': 'application/json',
			EditorToken: editorToken
		}}
	);	
	return response.data;
}

export async function postContentsSnapshot(emailId:number, data: HistoryItem, testGroup?: editorState['testGroup']) {
	let requestUrl = `/editor/${emailId}/content/snapshots`;
	if (testGroup) requestUrl = requestUrl + `?type=${testGroup}`;

	const response = await Http.post<Contents>(
		requestUrl,
		JSON.stringify(data),
		{headers: {
			'Content-Type': 'application/json',
		}}
	);	
	return response.data;
}

export async function requestContentsSnapshot(emailId:number, offset:number, testGroup?: editorState['testGroup']) {
	let requestUrl = `/editor/${emailId}/content/snapshots`;
	const queryParams = new URLSearchParams({ limit: 20, offset });
	if (testGroup) queryParams.append('type', testGroup);
	
	try {
		const response = await Http.get(requestUrl, { params: queryParams });
		return response.data;
	} catch (error) {
		console.error(error);
		return [];
	}
}

export async function checkoutSnapshot(emailId:number, snapshotId: number) {
	try {
		const response = await Http.post(
			`/editor/${emailId}/content/snapshots/${snapshotId}/checkout`
		);
		return response.data;
	} catch (error) {
		console.error(error);
		return error;
	}
}

export async function requestAddContent(emailId:number, data: any) {
	const response = await Http.post<Contents>(
		`/editor/${emailId}/contents`,
		qs.stringify(data),
		{
			headers: {
				'enctype': 'multipart/form-data'
			}
		}
	);
	return response.data;
}

export async function requestRemoveContent(emailId:number, contentId: string) {
	const response = await Http.delete<Contents>(
		`/editor/${emailId}/contents/${contentId}`,
	);
	return response.data;
}

export async function requestCopyContent(emailId:number, contentId: string, seqTo:number) {
	const response = await Http.post<Contents>(
		`/editor/${emailId}/contents/${contentId}/copy`,
		qs.stringify({seqTo: seqTo}),
	);
	return response.data;
}

export async function requestEmail(emailId:number) {
	const response = await Http.get<Email>(
		`/emails/${emailId}`
	);
	return response.data;	
}

export async function requestGenerateHtml(data:any, option?: { newHtmlRendering?: boolean; }) {	
	const { newHtmlRendering = false } = option || {};
  const isForWeb = data.supportType === 'WEB';
	const generatorVersion = (!isForWeb && newHtmlRendering) ? 'v3' : 'v2';

	let requestUrl = service.htmlPath[generatorVersion];
	
	const response = await Http.post(
		requestUrl,
		JSON.stringify(data),
		{
			headers: {
				'Content-Type': 'application/json',
				accessToken: null
			}
		}
	);
	return response.data;	
}

export async function requestSaveHtml(emailId: number, output: any, { purpose, ...options }: { type?: string; purpose?: 'WEB'; } = {}) {	
	const subpath = purpose === 'WEB' ? '/web' : '';
	const _options = { ...options };
	if (!_options.type) {
		delete _options.type;
	}
	const queryParams = new URLSearchParams(options);
	let queryString = queryParams.toString();
	queryString = queryString.length > 0 ? `?${queryString}` : '';

	const response = await Http.put(
		`/editor/${emailId}/contents/html${subpath}${queryString}`,
		qs.stringify({ html: output }),
		{
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
			}
		}
	);
	return response.data;	
}

export async function requestContainer(emailId: number, testGroup?: editorState['testGroup']) {
	let requestUrl = `/editor/${emailId}/contents/style`;
	if (testGroup) requestUrl = requestUrl + `?type=${testGroup}`;

	const response = await Http.get<Container>(
		requestUrl,
	);	
	return response.data;
}

export async function putContainer(emailId:number, data: any, testGroup?: editorState['testGroup']) {
	let requestUrl = `/editor/${emailId}/contents/style`;
	if (testGroup) requestUrl = requestUrl + `?type=${testGroup}`;

	const response = await Http.put<Contents>(
		requestUrl,
		qs.stringify({ style: JSON.stringify(data) }),
		{
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
			}
		}
	);
	return response.data;
}

export async function requestFilesize(emailId:number, testGroup?: editorState['testGroup']) {
	let requestUrl = `/editor/${emailId}/contents/upload/size`;
	if (testGroup) requestUrl = requestUrl + `?type=${testGroup}`;

	const response = await Http.get<Contents>(requestUrl);
	return response.data;
}

// export async function putContent(emailId:number, contentId: string, data: any) {	
// 	const response = await Http.put<Contents>(
// 		`/editor/${emailId}/contents/${contentId}`,
// 		qs.stringify({content: JSON.stringify(data)}),
// 		{headers: {
// 			'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
// 		}}
// 	);	
// 	return response.data;
// }

export async function requestMoveContent(emailId:number, contentId: string, seqTo: number) {
	const response = await Http.put<Contents>(
		`/editor/${emailId}/contents/${contentId}/move`,
		qs.stringify({seqTo: seqTo}),
		// {
		// 	headers: {
		// 		'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
		// 	}
		// }
	);
	return response.data;
}

export async function uploadFile(emailId:number, data: any, testGroup?: editorState['testGroup']) {
	let requestUrl = `/editor/${emailId}/contents/upload`;
	if (testGroup) requestUrl = requestUrl + `?type=${testGroup}`;

	const response = await Http.post<Contents>(
		requestUrl,
		data,
		{
			headers: {
				'enctype': 'multipart/form-data'
			}
		}
	);	
	return response.data;
}

export async function requestSystemFields() {
	const response = await Http.get<MergeFields>(
		`/emails/merges`
	);

	return response.data;
}

export async function requestListVars(listId: string) {
	const response = await Http.get<ListVars>(
		`/lists/${listId}/vars`
	);
	return response.data;
}

export async function requestListInfo(listId: string) {
	const response = await Http.get<ListVars>(
		`/lists/${listId}`
	);
	return response.data;
}
export async function getYoutubeThumbnail(url: string, emailId: number) {
	const response = await Http.post(
		`${service.apipath}/editor/${emailId}/contents/generateThumbnail`,
		{ url: url },
		{
			headers: {
				'Content-Type': 'application/json; charset=UTF-8'
			},
		},
	);
	return response.data;
}

export async function requestShopProduct(keyword: string, shopNo: number = 1) {
	// sixshop의 경우 shopNo를 붙여서 보내도 서버에서 무시됨
	const response = await Http.get(
		`/shop/products?productName=${keyword}&shopNo=${shopNo}`
	);
	return response.data;
}

export async function requestShops() {
	const response = await Http.get('/shops');
	return response.data;
}

export async function requestAiRewrite(emailId: number, content: string, fullContent?: string) {
	try {
		const payload = fullContent ? 
			{ fullContent, content } :  // 새로운 API 형식
			{ content };               // 기존 호환성

		const response = await Http.post(
			`/editor/${emailId}/ai/rewrite`,
			JSON.stringify(payload),
			{
				headers: {
					'Content-Type': 'application/json'
				}
			}
		);
		return response.data;
	} catch (error) {
		console.error('requestAiRewrite error:', error);
		throw error;
	}
}

export async function requestRefreshCafe24Token() {
	const response = await Http.get(
		`/cafe24/oauth2/url`
	);
	return response.data;
}

export async function getDonusUrl() {
	const response = await Http.get(
		`/donus/donation-url`
	);
	return response.data;
}

export async function getDonusProducts() {
	const response = await Http.get(
		`/donus/products`
	);	
	return response.data?.productList === null ? {productList: []} : response.data;
}

export async function generateMap(address: string) {
	const geocoder = new daum.maps.services.Geocoder();

	const promise = new Promise((resolve:any, reject:any) => {
		geocoder.addressSearch(address, (result:any, status: number) => {
			
			if (result.length === 0) {
				resolve(status)
				return;
			}
	
			if (status === daum.maps.services.Status.OK) {
				const location = result[0];
				const {
					x,
					y,
					address_name: addressName,
				} = location;

				const coords = new daum.maps.LatLng(result[0].y, result[0].x);

				var staticMapContainer = document.getElementById('staticMap');	
				if (staticMapContainer) {
					staticMapContainer.innerHTML = '';
				}
				
				var staticMapOption = {
					center: coords,
					level: 3,
					marker: {
						position: coords,
						text: address
					}
				};
				new daum.maps.StaticMap(staticMapContainer, staticMapOption);
	
				const mapImg = document.querySelector('#staticMap img')?.getAttribute('src');
				const mapLink = `https://map.kakao.com/link/map/${encodeURIComponent(addressName)},${y},${x}`

				resolve ({image: mapImg, link: mapLink});
			}
	
		});	
	});
	
	return promise;
}

export async function getUnsplash(keyword:string, page:number) {
	const response = await Http.get(
		`https://api.unsplash.com/search/photos/?client_id=${service.unsplashSecret}&order_by=relevant&query=${keyword}&per_page=24&page=${page}`
	);	
	return response.data;
}

export async function getEditorToken(emailId:number) {
	const response = await Http.get(
		`/editor/token?emailId=${emailId}`
	);	
	return response.data;
}

export async function createEditorToken(emailId:number) {
	const response = await Http.post(
		`/editor/token?emailId=${emailId}`
	);	
	return response.data;
}

export async function removeUploadedImage(emailId:number, imageFileName:string, testGroup?: editorState['testGroup']) {
	let requestUrl = `/editor/${emailId}/contents/upload/${imageFileName}`;
	if (testGroup) requestUrl = requestUrl + `?type=${testGroup}`;

	const response = await Http.delete(requestUrl);	
	return response.data;
}

export async function getMetaInfo(emailId:number) {
  try {
    const response = await Http.get(
      `/editor/${emailId}/contents/meta`
    );
    return response.data;
  } catch (error) {
    console.log(error);
    return;
  }
}

export async function updateMetaInfo(emailId:number, data:any) {
	const formData = new FormData();
	formData.append("value", JSON.stringify(data));

	const response = await Http.put(
		`/editor/${emailId}/contents/meta`,
		formData,
		{
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
				EditorToken: editorToken,
			},
		}
	);
	return response.data;	
}

export async function getLastModifiedGroup (emailId: number) {
	const response = await Http.get(`/editor/${emailId}/contents/lastModified`);
	return response.data;
}

export async function syncTestGroupContents (emailId: number, from: 'A' | 'B', to: 'A' | 'B') {
	const response = await Http.put(`/editor/${emailId}/content/sync?from=${from}&to=${to}`);
	return response.data;
}

export async function getHtml (emailId: number, testGroup?: string) {
	let requestUrl = `/editor/${emailId}/contents/html`;
	if (testGroup) requestUrl = requestUrl + `?type=${testGroup}`;
	
	const response = await Http.get(requestUrl);
	return response;
}

// Saved Box API Functions
export async function saveSavedBox(boxData: { name: string; preset: any }): Promise<SavedBox> {
	try {
		const response = await Http.post<{data: SavedBox}>(
			'editor/presets',
			JSON.stringify(boxData),
			{
				headers: {
					'Content-Type': 'application/json',
					...(editorToken ? { EditorToken: editorToken } : {})
				}
			}
		);

		return response.data.data;
	} catch (error) {
		console.error('❌ API 호출 실패 - 상자 저장:', error);
		throw error;
	}
}

export async function loadSavedBoxes(offset = 0, limit = 15): Promise<SavedBoxListResponse> {
	const response = await Http.get<SavedBoxListResponse>(
		`/editor/presets`,
		{
							params: {
					offset: offset.toString(),
					limit: limit.toString()
				} as Record<string, string>,
			headers: {
				...(editorToken ? { EditorToken: editorToken } : {})
			}
		}
	);
	
	return response.data;
}

export async function updateSavedBox(id: string, name: string): Promise<void> {
	const response = await Http.put(
		`/editor/presets/${id}`,
		JSON.stringify({ name }),
		{
			headers: {
				'Content-Type': 'application/json',
				...(editorToken ? { EditorToken: editorToken } : {})
			}
		}
	);
	
}

export async function deleteSavedBox(id: string): Promise<void> {
	const response = await Http.delete(
		`/editor/presets/${id}`,
		{
			headers: {
				...(editorToken ? { EditorToken: editorToken } : {})
			}
		}
	);
	
}

export async function loadSavedBoxDetail(id: string): Promise<any> {
	const response = await Http.get(
		`/editor/presets/${id}`,
		{
			headers: {
				...(editorToken ? { EditorToken: editorToken } : {})
			}
		}
	);
	
	return response.data;
}